import React from 'react';
import { NAVIGATION_KEYS } from '../../../i18n/constants/keys';
import { Permission } from '../../../utils/helpers/permissions';

type SidebarSubItem = {
  labelKey: string;
  to?: string;
  permissionGate?: {
    requiredPermissions: Permission[];
    matchAnyPermission: boolean;
  };
  divider?: boolean;
};

export type SidebarItem = {
  labelKey: string;
  icon: JSX.Element;
  assignedPermissions: Permission[];
  matchAnyPermission: boolean;
  to: string;
  isPublicRoute?: boolean;
  subItems?: SidebarSubItem[];
};

const SidebarIcon = ({ src, alt }: { src: string; alt: string }) => (
  <img
      src={`${process.env.PUBLIC_URL}/icons/${src}`}
      alt={alt}
      className='block h-5 w-5 object-contain'
  />
);

export const PrivateSidebarItems: SidebarItem[] = [
  {
    labelKey: NAVIGATION_KEYS.sidebar.dashboard,
    icon: <SidebarIcon src='Dashboard.svg' alt='Dashboard' />,
    assignedPermissions: [],
    matchAnyPermission: false,
    to: '/home',
  },
  {
    labelKey: NAVIGATION_KEYS.sidebar.hierTalent,
    icon: <SidebarIcon src='hireTalnt.svg' alt='HierTalent' />,
    assignedPermissions: [
      Permission.ASSESSMENTS_CREATE,
      Permission.QUESTIONS_VIEW,
    ],
    matchAnyPermission: false,
    to: '/job-openings-list',
  },
  {
    labelKey: NAVIGATION_KEYS.sidebar.questions,
    icon: <SidebarIcon src='QnA.svg' alt='Questions' />,
    assignedPermissions: [Permission.QUESTIONS_VIEW],
    matchAnyPermission: false,
    to: '',
    subItems: [
      {
        labelKey: NAVIGATION_KEYS.sidebar.questionBank,
        to: '/question-bank',
        permissionGate: {
          requiredPermissions: [Permission.QUESTIONS_VIEW],
          matchAnyPermission: true,
        },
      },
      {
        labelKey: NAVIGATION_KEYS.sidebar.preScreenQuestions,
        to: '/pre-screen-bank',
        permissionGate: {
          requiredPermissions: [Permission.QUESTIONS_VIEW],
          matchAnyPermission: true,
        },
      },
      {
        labelKey: NAVIGATION_KEYS.sidebar.contentManager,
        to: '/content-manager',
        permissionGate: {
          requiredPermissions: [Permission.JOB_VIEW],
          matchAnyPermission: true,
        },
      },
      {
        labelKey: NAVIGATION_KEYS.sidebar.autoGenerateQuestions,
        to: '/upload-file',
        permissionGate: {
          requiredPermissions: [Permission.JOB_CREATE],
          matchAnyPermission: true,
        },
      },
      {
        labelKey: NAVIGATION_KEYS.sidebar.ccaQuestions,
        to: '/cca-questions',
        permissionGate: {
          requiredPermissions: [Permission.QUESTIONS_VIEW],
          matchAnyPermission: true,
        },
      },
    ],
  },
  {
    labelKey: NAVIGATION_KEYS.sidebar.reporting,
    icon: <SidebarIcon src='Reports.svg' alt='Reporting' />,
    assignedPermissions: [],
    matchAnyPermission: false,
    to: '/reporting',
  },
];

export const PublicSidebarItems: SidebarItem[] = [
  {
    labelKey: NAVIGATION_KEYS.sidebar.jobPostings,
    icon: <SidebarIcon src='JobOpenings.svg' alt='Job Postings' />,
    assignedPermissions: [],
    matchAnyPermission: false,
    to: '/jobs',
    isPublicRoute: true,
  },
  {
    labelKey: NAVIGATION_KEYS.sidebar.candibankExplorer,
    icon: <SidebarIcon src='Candibank.svg' alt='Candibank Explorer' />,
    assignedPermissions: [],
    matchAnyPermission: false,
    to: '/candibank-explorer',
    isPublicRoute: true,
  },
];
